<template>
  <div id="login">
    <Hero heroImage="./img/samuel-zeller-367971-unsplash.jpg"/>
    <LoginForm />
  </div>
</template>

<script>
import Hero from '../components/Hero.vue';
import LoginForm from '../components/LoginForm.vue';

export default {
  name: 'Login',
  components: {
    Hero,
    LoginForm,
  },
  data() {
    return {
      sharedStore: this.$root.store,
    };
  },
  created() {
    const token = this.sharedStore.getToken();

    if (token !== undefined && token !== null) {
      if (token.length > 0) {
        window.location.href = '/dashboard';
      }
    }
  },
};
</script>

<style scoped lang="scss">

</style>
